import { render } from "./App.vue?vue&type=template&id=24be4fe0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=24be4fe0&lang=css"

import exportComponent from "/home/runner/work/bayes-intraday-pwa-rt/bayes-intraday-pwa-rt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__